import { Fleet } from '../interfaces';

export const isLondon = (fleet: Fleet) =>
  // FIXME use a proper feature flag here - this is just temporary so we can test in a non-eu tenant ENV
  fleet.display_name?.toLowerCase().includes('london') || fleet.display_name?.toLowerCase().includes('tfl');
